import React from 'react'

const FullNameIcon = () => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5664 12C21.5664 17.2834 17.2834 21.5664 12 21.5664C6.71662 21.5664 2.43359 17.2834 2.43359 12C2.43359 6.71662 6.71662 2.43359 12 2.43359C17.2834 2.43359 21.5664 6.71662 21.5664 12ZM14.8964 13.2251C13.3065 12.1652 10.7137 12.1652 9.11244 13.2251C8.38874 13.7095 7.98984 14.3648 7.98984 15.0658C7.98984 15.7667 8.38874 16.4163 9.10674 16.895C9.90453 17.4306 10.953 17.6984 12.0016 17.6984C13.0501 17.6984 14.0986 17.4306 14.8964 16.895C15.6144 16.4106 16.0133 15.761 16.0133 15.0544C16.0076 14.3534 15.6144 13.7038 14.8964 13.2251ZM9.28948 9.00842C9.28948 7.51542 10.5033 6.30164 11.9963 6.30164C13.4893 6.30164 14.703 7.51542 14.703 9.00842C14.6973 10.4729 13.5519 11.6582 12.0931 11.7095H12.0817H12.0532C12.019 11.7038 11.9735 11.7038 11.9279 11.7095C10.4349 11.6582 9.28948 10.4729 9.28948 9.00842Z" fill="#6167A0" />
        </svg>

    )
}

export default FullNameIcon